/* global global */
import { put, select, takeEvery } from 'redux-saga/effects'
// React Intl v5+ ya no necesita addLocaleData
// import { addLocaleData } from 'react-intl'

import * as LanguageImporter from './i18n.helpers'
import * as actions from './i18n.actions'
import * as authActions from '../Auth/auth.actions'
import * as authSelectors from '../Auth/auth.selectors'
import * as tutorialActions from '../../Tutorial/tutorial.actions'
import * as tutorialSelectors from '../../Tutorial/tutorial.selectors'

function* loadI18nBasic(locale) {
  let localeData
  const lowerCaseLocale = locale.toLowerCase()
  const languageCodeOnly = lowerCaseLocale.split('-')[0]

  if (globalThis.$$NativeIntlUnsupported) {
    let intlPathLocale = languageCodeOnly
    const parts = lowerCaseLocale.split('-')
    if (parts.length > 1 && parts[1]) {
      intlPathLocale += '-' + parts[1].toUpperCase() // ej. 'pt' + '-' + 'BR' = 'pt-BR'
    }
    // localeData = yield import(`intl/locale-data/jsonp/${intlPathLocale}.js`)
    localeData = null
  } else {
    // localeData = yield import(`react-intl/locale-data/${languageCodeOnly}`)
    localeData = null
  }
  let messages = yield LanguageImporter.importLanguage(locale)
  // addLocaleData ya no es necesario en React Intl v5+
  // addLocaleData(localeData)

  try {
    window.SessionStorage.setItem('locale', locale)
  } catch (e) {
    // No empty block ;-)
  }
  yield put(actions.loadI18nMessagesFinish(locale, messages))
}

/**
 *  Load i18n messages acording to locale
 *  @param   {object}     action  Redux action
 */
export function* loadI18nMessages() {
  const userInfo = yield select(authSelectors.getUserInfo)
  const locale = window.SessionStorage.getItem('locale') || userInfo.licenseData.lang || 'en'
  yield loadI18nBasic(locale)
}

export function* loadI18nTutorialMessages() {
  const userInfo = yield select(tutorialSelectors.getUserInfo)
  const locale = userInfo.licenseData.lang || 'en'
  yield loadI18nBasic(locale)
}

/**
 *  Initialize i18n
 */
export function* initI18n() {
  // Add i18n EMACS API support
  if (!globalThis.Intl) {
    globalThis.$$NativeIntlUnsupported = true
    // yield import('intl')
    // Intl polyfill ya no es necesario en navegadores modernos
  }

  try {
    yield put(actions.loadI18nMessagesStart())
  } catch (e) {
    // No empty block ;-)
  }
}

/**
 *  I18n sagas
 */
export function* sagas() {
  yield takeEvery(
    [
      authActions.USER_INFO_FINISH_SUCCESS,
      // actions.SYNC_I18N,
    ],
    loadI18nMessages
  )

  yield takeEvery(tutorialActions.LOAD_I18N_MESSAGES, loadI18nTutorialMessages)
  yield initI18n()
}
